export default {
    manage_deleteVehicleStatus_deleteStatusLabel: "Eliminar Etiqueta de Estado",
    manage_deleteVehicleStatus_deleteStatusLabels: "Eliminar Etiquetas de Estado",
    manage_deleteVehicleStatus_confirmationMessage:
      "¿Está seguro de que desea eliminar las siguientes Etiquetas de Estado?"
  };
  